import { all } from 'redux-saga/effects';
import { watchFetchUserProfile } from './setCurrentUserAsync';
import { wathcMessagingUI } from './setPrivateMessagingState';
import { watchUserLogout } from './logoutUser';

export default function* rootSaga() {
  yield all([watchFetchUserProfile(), watchUserLogout(), wathcMessagingUI()]);
}
